import './App-types';

const lock = (root?: HTMLBodyElement) => {
    const body = root || document.getElementsByTagName('body')[0];

    if (body) {
        body.style['overflow'] = 'hidden';
    }
}

const unlock = (root?: HTMLBodyElement) => {
    const body = root || document.getElementsByTagName('body')[0];

    if (body) {
        body.style['overflow'] = 'auto';
    }
}

const toggle = () => {
    const body = document.getElementsByTagName('body')[0];

    if (body) {
        body.style['overflow'] === 'hidden'
            ? window.scrollbar.unlock(body)
            : window.scrollbar.lock(body);
    }
}

window.scrollbar = {
    lock,
    unlock,
    toggle,
}
